const { makeStyles } = require("@material-ui/core");

const useStyles = makeStyles((theme)=>({

    root:{
        flexGrow:'1',
    }
})
);

export default useStyles;